import type { ReactNode, JSX } from 'react';
import { formatTimeToDate, getContentImageUrl } from 'utils/app';

/**
 * レポート詳細画面のヘッダー共通コンポーネント（Quiz/Diagnosis/Form 共通）
 * 画像 + タイトル + 登録日時 + StatusBadge + 戻る + コンテンツ確認 + レポート出力
 */
export default function WsReportDetailHeader(props: {
  imageKey: string | null;
  title: string;
  createdAt: number;
  statusBadge: ReactNode;
  isExpiredPlan: boolean;
  onBack: () => void;
  onContentOpen: () => void;
  onModalReportDownloadOpen: () => void;
}): JSX.Element {
  const {
    imageKey,
    title,
    createdAt,
    statusBadge,
    isExpiredPlan,
    onBack,
    onContentOpen,
    onModalReportDownloadOpen,
  } = props;

  return (
    <section className="section-header report-detail">
      <div className="container">
        <a onClick={onBack} className="btn-back-list hover">
          戻る
        </a>

        <div className="card card-detail">
          <div className="card-body">
            <div className="d-md-flex d-flex-detail">
              <div className="flex-shrink-0 flex-left">
                <dl className="dl-list-indent">
                  <dt>
                    <div className="flex-shrink-0 flex-img" style={{ width: '75px' }}>
                      <img src={getContentImageUrl(imageKey)} className="img-fluid" />
                    </div>
                  </dt>

                  <dd>
                    <p className="caption">{title}</p>
                    <span className="date">
                      {formatTimeToDate(createdAt, 'yyyy年M月dd日 h:mm a')}
                    </span>
                    {statusBadge}
                  </dd>
                </dl>
              </div>
              <div className="flex-grow-1 flex-right">
                <a onClick={onContentOpen} className="btn btn-common btn-common-w238 moderate-blue">
                  コンテンツを確認
                </a>
                <a
                  onClick={onModalReportDownloadOpen}
                  className={
                    isExpiredPlan
                      ? 'btn btn-disabled btn-common-w238 outline-blue'
                      : 'btn btn-common btn-common-w238 outline-blue'
                  }
                  data-tooltip-id="custom-tooltip"
                  data-tooltip-content="プランの期限がきれました。プランのアップグレードをご検討ください。"
                >
                  レポート出力
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
